<div *ngIf="!data.captionCenter">
  <h1 mat-dialog-title class="captionLeft">{{ data.caption }}</h1>
</div>
<div *ngIf="data.captionCenter">
  <h1 mat-dialog-title>{{ data.caption }}</h1>
</div>
<mat-dialog-content class="dialog-container">
  <div class="icon-container">
    <mat-icon class="warning-icon">report_problem</mat-icon>
  </div>
  <ul class="warning-text">
    <li *ngFor="let warningString of data.warningMessage">
      {{ warningString }}
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-button [mat-dialog-close]="false" *ngIf="data.cancelButtonShow">
    Cancel
  </button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>
